import React from "react";
import noop from "mn-utils/noop";
import {Grid, ScrollSync} from "react-virtualized";
import {CircularProgress} from "@material-ui/core";

import {tableScroll$} from "../../utils/tableScroll";
import ActionDropdown from "../ActionsDropdown";


export default (props) => {

  const {
    registerChild,
    onRowsRendered = noop,

    width = 0,
    height = 0,

    headerHeight = 0,
    rowHeight = 0,
    rowCount = 0,
    columnsTotalWidth = 0,

    className,
    headerRowClass,
    headerColClass,
    rowClass,
    colClass,
    actionClass,
    noDataClass,

    columns = [],
    list = [],
    loading,
    actions,
    update
  } = props;

  const calcColWidth = ({index}) => {
    const col = columns[index] || {};
    return col.minWidth || col.width || 150;
  }

  const cellRenderer = ({ columnIndex, rowIndex, style, parent, ...rest }) => {
    const itemParams = columns[columnIndex] || {};
    const row = list[rowIndex] || {};

    const key = itemParams.dataKey;
    const dataHandler = itemParams.dataHandler;

    const value = (dataHandler ? dataHandler(row) : row[key]) || '';
    const oddClass = rowIndex % 2 === 0 ? 'odd' : 'even';

    return (
      <>
        <div key={`${rowIndex}-${columnIndex}`} className={[colClass, oddClass].join(' ')} style={{...style}}>
          <div>
            {value}
          </div>
        </div>
        {columnIndex === 0 && !!actions && (
          <div
            key={`${rowIndex}-actions`}
            className={[actionClass, oddClass].join(' ')}
            style={{
              height: style.height,
              top: style.top,
              zIndex: 100
            }}
          >
            <ActionDropdown
              id={`${rowIndex}-actions`}
              rowData={row}
              actions={actions}
              update={update}
            />
          </div>
        )}
      </>
    )
  }

  const headerRenderer = ({columnIndex, style}) => {
    return (
      <div key={columnIndex} className={headerColClass} style={style}>
        {(columns[columnIndex] || {}).label}
      </div>
    )
  }

  let scrollInit = true;
  const INITIAL_SCROLL_TOP = Number(tableScroll$.getValue() || 0);

  return (
    <ScrollSync>
      {({scrollLeft, onScroll}) => (
        <div key={1} className={`${className} grid`}>
          <div
            key={1}
            className={headerRowClass}
            style={{
              position: 'relative',
              height: headerHeight,
              width: width,
            }}
          >
            <Grid
              key={1}
              columnWidth={calcColWidth}
              columnCount={columns.length + 1}
              height={headerHeight}
              overscanColumnCount={columns.length}
              cellRenderer={headerRenderer}
              rowHeight={headerHeight}
              rowCount={1}
              scrollLeft={scrollLeft}
              width={!!rowCount ? width : width}
              style={{
                // left: `-${props.scrollLeft}px` || 0,
                overflow: 'hidden',
              }}
            />
            <div
              key={2}
              className={`${className}__header-scroll`}
            />
          </div>
          <div
            key={3}
            className={rowClass}
            style={{
              height: height - headerHeight,
              width,
            }}
          >
            {!!rowCount
              ? (
                <Grid
                  key={4}
                  ref={registerChild}
                  className={colClass}
                  columnWidth={calcColWidth}
                  columnCount={columns.length}
                  height={height - headerHeight}
                  overscanColumnCount={columns.length}
                  cellRenderer={cellRenderer}
                  rowHeight={rowHeight}
                  rowCount={rowCount}
                  isScrollingOptOut={true}
                  overscanIndicesGetter={({cellCount}) => ({
                    overscanStartIndex: 0,
                    overscanStopIndex: cellCount - 1,
                  })}
                  onScroll={(params) => {
                    const {scrollHeight, scrollTop, scrollLeft} = params;

                    if (scrollInit) scrollInit = false;
                    if (
                      scrollHeight
                      && scrollTop
                      && tableScroll$.getValue() !== scrollTop
                    ) {
                      tableScroll$.emit(params.scrollTop);
                    }

                    onScroll(params);
                  }}
                  scrollTop={INITIAL_SCROLL_TOP}
                  onSectionRendered={({ rowStartIndex, rowStopIndex }) => {
                    onRowsRendered({
                      startIndex: rowStartIndex,
                      stopIndex: rowStopIndex
                    })
                  }}
                  width={width}
                />
              ) : (
                <Grid
                  key={4}
                  ref={registerChild}
                  className={colClass}
                  columnWidth={columnsTotalWidth}
                  columnCount={1}
                  height={rowHeight + 8}
                  overscanColumnCount={columns.length}
                  cellRenderer={() => {
                    return (
                      <div
                        className={noDataClass}
                        style={{width: columnsTotalWidth}}
                      >
                        {props.loading
                          ? <CircularProgress />
                          : 'No Data'
                        }
                      </div>
                    )
                  }}
                  rowHeight={rowHeight}
                  rowCount={1}
                  onScroll={props.onScroll}
                  width={width}
                />
              )}
          </div>
        </div>
      )}
    </ScrollSync>
  )
}
